import { useEffect } from 'react';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import { themeScrollbarCss } from '@utils/themeScrollbar';

/** App-wide scrollbars, same treatment as the invoice editor, following light/dark theme. */
export default function ThemeScrollbars() {
  const light = themeSelector();

  useEffect(() => {
    if (typeof document === 'undefined') return undefined;
    const style = document.createElement('style');
    style.id = 'app-scrollbar-styles';
    style.textContent = themeScrollbarCss('*', Boolean(light));
    document.getElementById(style.id)?.remove();
    document.head.appendChild(style);
    return () => {
      style.remove();
    };
  }, [light]);

  return null;
}
